import predefinedEntities from "./global-entities.json";
import { patchArray } from "../utils/data-utils";

const entities = [
  {
    id: "scene",
    scene: {
      background: 0xffffff,
      environment: "{context.tractor.state.environment}_env",
    },
  },
  {
    id: "camera",
    camera: {
      position: [5, 2, -2],
      target: [1, 0, 0],
    },
  },
];

export default patchArray(predefinedEntities, entities);
